// @flow

import type { State } from "@store/reducers";
import type {
  NewShiftPattern,
  ShiftPattern,
  UnassignReassignShiftPatternModalType,
  EmployeePositionsAssignedToShiftPattern,
  DepartmentsAssignedToShiftPattern,
  DraftShiftPattern,
} from "@modules/service/reducer/shift-patterns/types";

export const getShiftPatternsPagination = (state: State) => {
  return (((state.service || {}).shiftPatterns || {}).list || {}).pagination;
};

export const getShiftPatternsTotalElements = (state: State) => {
  return (state.service.shiftPatterns.list || {}).totalElements;
};

export const getCurrentShiftPattern = (state: State): ShiftPattern | NewShiftPattern =>
  state.service.shiftPatterns.current;

export const employeePositionsAssignedToShiftPattern = (
  state: State,
): ?Array<EmployeePositionsAssignedToShiftPattern> =>
  state.service.shiftPatterns.employeePositionsAssignedToShiftPattern;

export const getShiftPatternDraft = (state: State): ?DraftShiftPattern =>
  state.service.shiftPatterns.draft;

export const departmentsAssignedToShiftPattern = (
  state: State,
): ?Array<DepartmentsAssignedToShiftPattern> =>
  state.service.shiftPatterns.departmentsAssignedToShiftPattern;

export const getShiftPatternsList = (state: State): Array<ShiftPattern> =>
  state.service.shiftPatterns.list.content;

export const getShowAddShiftPatternModal = (state: State): boolean =>
  state.service.shiftPatterns.modals.showAddModal;

export const getShowEditShiftPatternModal = (state: State): boolean =>
  state.service.shiftPatterns.modals.showEditModal;

export const getShowDeleteShiftPatternModal = (state: State): boolean =>
  state.service.shiftPatterns.modals.showDeleteModal;

export const isUnassignReassignShiftPatternModalVisible = (state: State): boolean =>
  state.service.shiftPatterns.modals.unassignReassignShiftPatternModal.visible;

export const unassignReassignShiftPatternModalType = (
  state: State,
): ?UnassignReassignShiftPatternModalType =>
  state.service.shiftPatterns.modals.unassignReassignShiftPatternModal.type;

export const getSelectedShiftPattern = (state: State): ?ShiftPattern =>
  state.service.shiftPatterns.modals.unassignReassignShiftPatternModal.shiftPattern;

export const shiftPatternIdToReassign = (state: State): number =>
  ((state.form["reassign-items-to-shift-pattern"] || {}).values || {}).newShiftPatternId || 0;

export const isReassignItemsToShiftPatternModalVisible = (state: State): boolean =>
  state.service.shiftPatterns.modals.reassignItemsToShiftPatternModal.visible;

export const getTotalShiftPatternsList = (state: State) => {
  return ((state.service || {}).shiftPatterns || {}).totalList;
};
